module.exports = __webpack_public_path__ + "static/media/infoIcon.7fbe069f.svg";